import axios from 'axios';
import toast from 'react-hot-toast';
import config from 'src/config';
import storage from 'src/storage';

const api = axios.create({ baseURL: config.rootUrl });

api.interceptors.request.use(
  async configs => {
    try {
      const token = await storage.getToken();
      if (token) {
        configs.headers = {
          Authorization: `Bearer ${token}`
        };
      }
    } catch (error) {
      console.log('err token...', error?.message, '..');
    }
    return configs;
  },
  error => Promise.reject(error)
);

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // No response at all (offline, DNS, CORS). axios 0.21 sets no error.code
    // here, so test for the missing response instead (ISSUE-0201).
    if (!error?.response) {
      toast.error('Check your internet connection');
      return Promise.reject(error);
    }
    const { status } = error.response;
    // Any 401 means the signed-in session is gone: expired, tampered or
    // malformed token, no token, password reset, admin deactivated or
    // deleted. Matching only some of those messages left the tab stuck in
    // /app with every request failing (ISSUE-0244). The exceptions are a
    // failed sign-in, which LoginView reports itself, and "Not a super
    // admin", which the API now sends as a 403. A 404 "Admin not found" is
    // about the admin being viewed, so it must not log anyone out; and the
    // error always reaches the caller so its own toast shows (ISSUE-0241).
    const isSignIn = error.config?.url?.endsWith('/auth/admin/signin');
    if (status === 401 && !isSignIn) {
      storage.removeUser();
      // id dedupes the toast when several requests 401 together (ISSUE-0230)
      toast.error('Your session has ended. Please log in again.', {
        id: 'session-ended'
      });
      // Leave /app: the dashboard otherwise stays open with every request
      // failing. The full load drops the toast, so LoginView repeats it.
      if (window.location.pathname !== '/login') {
        window.location.replace('/login?session=ended');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
